import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Eksporterer brugerprofiler", -1)
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-0 text-muted" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Vi fandt ")
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_organization_modal = _resolveComponent("organization-modal")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_organization_modal, { ref: "organizationModal" }, null, 512),
    _createVNode(_component_Dialog, {
      visible: _ctx.isExporting,
      closable: false,
      draggable: false,
      modal: true
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createVNode("p", _hoisted_2, " Anmoder om organisationer " + _toDisplayString(_ctx.batchFrom) + "-" + _toDisplayString(_ctx.exportedCount) + " af " + _toDisplayString(_ctx.totalCount) + " - venter på server… ", 1),
        _createVNode("p", _hoisted_3, [
          _createVNode("span", null, " Færdig med at hente " + _toDisplayString(_ctx.finishedCount) + " af " + _toDisplayString(_ctx.totalCount), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_page, {
      isLoading: _ctx.loading,
      error: _ctx.error
    }, {
      default: _withCtx(() => [
        (_ctx.organizations)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_AppHeader, {
                searchPlaceholder: "Søg efter organisationer her...",
                canSearch: true,
                searchEntry: _ctx.searchText,
                "onUpdate:searchEntry": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event)),
                actionButtonTitle: 
          _ctx.canCreateOrganizations ? 'Opret organisation' : undefined
        ,
                onOnActionButton: _cache[2] || (_cache[2] = ($event: any) => (_ctx.organizationModal?.show(null))),
                title: "Organisationer",
                exportUserProfilesToExcelTitle: 
          _ctx.canExportUserProfiles
            ? 'Eksportér brugerprofiler til Excel'
            : undefined
        ,
                onExportUserProfilesToExcel: _cache[3] || (_cache[3] = () => _ctx.exportAll(_ctx.organizations?.items ?? [])),
                exportUserProfilesToExcelLoading: _ctx.isExporting
              }, {
                subtitle: _withCtx(() => [
                  (_ctx.organizations)
                    ? (_openBlock(), _createBlock("strong", _hoisted_4, [
                        _hoisted_5,
                        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.filteredCount), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.usePluralFilter(_ctx.filteredCount, "organisation")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["searchEntry", "actionButtonTitle", "exportUserProfilesToExcelTitle", "exportUserProfilesToExcelLoading"]),
              _createVNode(_component_DataTable, {
                sortField: "name",
                sortOrder: 1,
                responsiveLayout: "scroll",
                filters: _ctx.filters,
                "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
                selectionMode: "single",
                globalFilterFields: ['name', 'vat', 'organizationId'],
                onRowSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onRowSelect($event.data))),
                value: _ctx.organizations.items,
                class: "bg-white rounded text-start",
                onFilter: _ctx.onFilter
              }, {
                empty: _withCtx(() => [
                  _createVNode(_component_error, {
                    error: {
              title: _ctx.filters.global.value
                ? 'Ingen resultatet'
                : 'Ingen organisationer',
              message: _ctx.filters.global.value
                ? 'Din søgning gav ingen resultater'
                : 'Der er ikke nogle organisationer oprettet i brugerkataloget endnu',
            }
                  }, null, 8, ["error"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    sortable: true,
                    field: "name"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createVNode("strong", null, _toDisplayString(data.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, null, {
                    body: _withCtx((slotProps) => [
                      _createVNode("div", _hoisted_7, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "me-4 text-primary",
                          icon: ['fas', 'users']
                        }),
                        _createTextVNode(" " + _toDisplayString(slotProps.data.userCount) + " profiler ", 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["filters", "value", "onFilter"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isLoading", "error"])
  ], 64))
}